// Label & warna status (port ST v1 di core.js).
export const ST = {
  spo: {
    diajukan: ['Menunggu verifikasi', 't-warn'],
    diverifikasi: ['Jadi nota', 't-ok'],
    ditolak: ['Ditolak', 't-danger'],
    batal: ['Batal', 't-slate'],
  },
  nota: {
    disiapkan: ['Disiapkan', 't-warn'],
    dimuat: ['Dimuat', 't-info'],
    dikirim: ['Dalam perjalanan', 't-violet'],
    terkirim: ['Terkirim', 't-teal'],
    gagal: ['Gagal kirim', 't-danger'],
    selesai: ['Selesai', 't-ok'],
    batal: ['Batal', 't-slate'],
  },
  pay: { belum: ['Belum bayar', 't-danger'], sebagian: ['Sebagian', 't-warn'], lunas: ['Lunas', 't-ok'] },
  pm: { cash: ['Cash', 't-ok'], transfer: ['Transfer', 't-info'], tempo: ['Tempo', 't-violet'] },
  payment: { sah: ['Sah', 't-ok'], menunggu: ['Menunggu konfirmasi', 't-warn'], ditolak: ['Ditolak', 't-danger'] },
  move: {
    masuk: ['Masuk', 't-ok'],
    keluar: ['Keluar', 't-info'],
    retur: ['Retur', 't-violet'],
    penyesuaian: ['Penyesuaian', 't-warn'],
  },
} as const satisfies Record<string, Record<string, readonly [string, string]>>;

export type StatusKind = keyof typeof ST;

export const statusOf = (kind: StatusKind, v: unknown): readonly [string, string] =>
  (ST[kind] as Record<string, readonly [string, string]>)[String(v)] ?? [String(v ?? ''), 't-slate'];

export const label = (kind: StatusKind, v: unknown): string => statusOf(kind, v)[0];

/** Cara persetujuan SPO (sign_via) → teks. */
export const SIGN_VIA_LABEL: Record<string, string> = {
  sales: 'TTD di HP sales',
  toko: 'TTD di aplikasi toko',
  toko_app: 'dipesan sendiri oleh toko',
  admin: 'dicatat admin/owner (tanpa TTD toko)',
  lama: 'data lama',
};
